























import { Vue, Prop, Component } from 'vue-property-decorator'
import BasePanel from '@/components/BasePanel/index.vue'
@Component({
  name: 'MiniTable2',
  components: { BasePanel }
})
export default class extends Vue {
  @Prop({ required: true }) private mainData: any

  get itemWidth() {
    return (100 / this.mainData.valueDescs.length) + '%'
  }
  go() {
    console.log(`/teachingProtection/assessment/compare/avgClass/detail?id=${this.mainData.id}`)
    this.$router.push(`/teachingProtection/assessment/compare/avgClass/detail?id=${this.mainData.id}`)
  }
}
